export default function useIsBeta() {
    return new URLSearchParams(window.location.search).get('beta') === 'true';
}
